import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Hero.module.scss';

function Hero(props) {
  const { children, title } = props;
  const style = props.divStyle || {};

  if (props.backgroundImage) {
    style.backgroundImage = `url(${props.backgroundImage})`;
  }

  return (
    <>
      <div className={cn(styles.hero, props.backgroundImage ? styles.hasBackgroundImage : '')} style={style}>
        {title && <h1>{title}</h1>}
        {children}
      </div>
    </>
  );
}

export default Hero;

Hero.defaultProps = {
  children: null,
  divStyle: null,
  backgroundImage: null,
};

Hero.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  divStyle: PropTypes.object,
  retailerId: PropTypes.number,
  backgroundImage: PropTypes.string,
};
